import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { FBoxContainer, FHTextarea } from '../../../base';
import { MINIMUM_REQUIRED_SENTENCE_LENGTH } from '../../../../constants';

import type { ChangeEvent } from 'react';
import type { IBtSupervision } from '../../../../utils/types';
interface AdditionalCommentsProps {
  isEditable: boolean;
  btSupervision: IBtSupervision;
  onUpdateValue: (key: string, value: string) => void;
}

function AdditionalComments({ isEditable, btSupervision, onUpdateValue }: AdditionalCommentsProps) {
  const { id: btSupervisionId } = useParams();
  const [additionalComments, setAdditionalComments] = useState<string | null>(null);
  const [isAdditionalCommentsError, setIsAdditionalCommentsError] = useState<boolean>(false);

  useEffect(() => {
    if (!btSupervisionId || btSupervisionId === 'new' || !btSupervision) {
      setAdditionalComments('');
      return;
    }
    setAdditionalComments(btSupervision.additional_comments);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [btSupervision]);

  useEffect(() => {
    const isAdditionalCommentsError =
      additionalComments !== null &&
      additionalComments?.trim().length < MINIMUM_REQUIRED_SENTENCE_LENGTH &&
      Boolean(btSupervision?.id);

    setIsAdditionalCommentsError(isAdditionalCommentsError);
  }, [additionalComments]);

  const handleUpdateComments = () => {
    if (!btSupervision || !btSupervisionId || additionalComments === null) {
      return;
    }
    onUpdateValue('additional_comments', additionalComments);
  };

  return (
    <FBoxContainer
      sx={{ mt: 3, borderRadius: '0px 0px 4px 4px', flex: 0 }}
      headerStyle={{ borderRadius: '4px 4px 0px 0px' }}
      title="Additional comments:"
    >
      <FHTextarea
        data-testid="additionalCommentsTextField"
        fullWidth
        minLength={MINIMUM_REQUIRED_SENTENCE_LENGTH}
        disabled={!isEditable}
        expandable={isEditable}
        placeholder="Please provide any additional comments:"
        value={additionalComments}
        onEdit={(e: ChangeEvent<HTMLTextAreaElement>) => {
          setAdditionalComments(e.target.value);
        }}
        onBlur={handleUpdateComments}
        error={isAdditionalCommentsError && isEditable}
        helperText={
          isAdditionalCommentsError &&
          `Minimum ${MINIMUM_REQUIRED_SENTENCE_LENGTH} characters are required`
        }
      />
    </FBoxContainer>
  );
}

export default AdditionalComments;
